<div class="employeeData-window">
	<div class="employeeData-selections">
		@for (position of employeeData.positions; track position; let i = $index) {
			<button (click)="handleButtonClick(i)" class="employeeDataButton" #buttons>
				{{ position.title }}
			</button>
		}
	</div>
	<div class="resultData" #resultData>
		@for (position of employeeData.positions; track position; let i = $index) {
			<div class="requestResultsDiv" #requestResultDiv>
				<app-employee-request-result
					[index]="i"
					[position]="position"
					class="employeeRequestResult"
				></app-employee-request-result>
			</div>
		}
	</div>
</div>
